(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orien-cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.orien-cart').forEach(function (root) {
    function changeItem(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function () {
        window.location.reload();
      });
    }

    root.querySelectorAll('[data-cart-row]').forEach(function (row) {
      var key = row.dataset.key;
      var input = row.querySelector('[data-cart-qty-input]');
      var decrease = row.querySelector('[data-cart-decrease]');
      var increase = row.querySelector('[data-cart-increase]');
      var remove = row.querySelector('[data-cart-remove]');

      if (decrease) {
        decrease.addEventListener('click', function () {
          var qty = Math.max(0, parseInt(input.value, 10) - 1);
          changeItem(key, qty);
        });
      }

      if (increase) {
        increase.addEventListener('click', function () {
          var qty = parseInt(input.value, 10) + 1;
          changeItem(key, qty);
        });
      }

      if (input) {
        input.addEventListener('change', function () {
          var qty = Math.max(0, parseInt(input.value, 10) || 0);
          changeItem(key, qty);
        });
      }

      if (remove) {
        remove.addEventListener('click', function () {
          changeItem(key, 0);
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orien-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.orien-header').forEach(function (root) {
    var sectionId = root.dataset.sectionId;
    var toggle = document.getElementById('OrienSearchToggle-' + sectionId);
    var form = document.getElementById('OrienSearchForm-' + sectionId);

    if (toggle && form) {
      toggle.addEventListener('click', function () {
        var isHidden = form.hasAttribute('hidden');
        if (isHidden) {
          form.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
          var input = form.querySelector('input[name="q"]');
          if (input) input.focus();
        } else {
          form.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orien-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.orien-pdp').forEach(function (root) {
    var sectionId = root.dataset.sectionId;
    var mainImage = document.getElementById('OrienMainImage-' + sectionId);
    var priceEl = document.getElementById('OrienPrice-' + sectionId);
    var subPriceEl = document.getElementById('OrienSubPrice-' + sectionId);
    var oneTimePriceEl = document.getElementById('OrienOneTimePrice-' + sectionId);
    var planSelect = document.getElementById('OrienPlanSelect-' + sectionId);
    var addToCartBtn = document.getElementById('OrienAddToCart-' + sectionId);
    var addToCartLabel = document.getElementById('OrienAddToCartLabel-' + sectionId);
    var errorEl = document.getElementById('OrienFormError-' + sectionId);
    var bundleCheckbox = document.getElementById('OrienBundleCheckbox-' + sectionId);

    var defaultVariantId = root.dataset.defaultVariantId;
    var variantPrices = {};
    if (defaultVariantId) {
      variantPrices[defaultVariantId] = parseInt(root.dataset.defaultVariantPrice, 10);
    }
    root.querySelectorAll('.orien-pdp__size-option').forEach(function (btn) {
      variantPrices[btn.dataset.variantId] = parseInt(btn.dataset.variantPrice, 10);
    });

    var activeVariantId = root.querySelector('.orien-pdp__size-option.is-active');
    activeVariantId = activeVariantId ? activeVariantId.dataset.variantId : (Object.keys(variantPrices)[0] || defaultVariantId);

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: root.dataset.currency });
    }

    function isSubscribed() {
      var checked = root.querySelector('input[name="orien-purchase-type"]:checked');
      return checked && checked.closest('.orien-pdp__purchase-option').querySelector('.orien-pdp__delivery-select') !== null;
    }

    function updateDisplay() {
      var price = variantPrices[activeVariantId];
      if (price === undefined) return;
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (oneTimePriceEl) oneTimePriceEl.textContent = formatMoney(price);

      var subscribed = isSubscribed();
      var label = subscribed && subPriceEl ? subPriceEl.textContent.replace('/bag', '') : formatMoney(price);
      if (addToCartLabel) addToCartLabel.textContent = 'Add to Cart — ' + label.trim();
    }

    root.querySelectorAll('.orien-pdp__size-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.orien-pdp__size-option').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        activeVariantId = btn.dataset.variantId;
        updateDisplay();
      });
    });

    root.querySelectorAll('input[name="orien-purchase-type"]').forEach(function (radio) {
      radio.addEventListener('change', updateDisplay);
    });

    if (planSelect) {
      planSelect.addEventListener('change', updateDisplay);
    }

    root.querySelectorAll('.orien-pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('.orien-pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImage) mainImage.src = thumb.dataset.imageUrl;
      });
    });

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        errorEl.hidden = true;
        var items = [{ id: parseInt(activeVariantId, 10), quantity: 1 }];

        var subscribed = isSubscribed();
        if (subscribed && planSelect) {
          items[0].selling_plan = parseInt(planSelect.value, 10);
        }

        if (bundleCheckbox && bundleCheckbox.checked) {
          items.push({ id: parseInt(bundleCheckbox.dataset.variantId, 10), quantity: 1 });
        }

        addToCartBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Something went wrong'); });
            return res.json();
          })
          .then(function () {
            window.location.href = root.dataset.cartUrl;
          })
          .catch(function (err) {
            errorEl.textContent = err.message;
            errorEl.hidden = false;
            addToCartBtn.disabled = false;
          });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
